import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reportePlanilla';
import AusenciasGrid from './AusenciasGrid';

const mstp = state => {
    return {
        ...state.reportePlanilla,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(AusenciasGrid)
